module.exports = __webpack_public_path__ + "sb.8d947efdfa062f907a9f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sb.svg
// module chunks = styles